/** Logical TV geometry, independent of the editor's available screen space. */
export function tvMetrics(viewportHeight: number, bannerHeight = 0, viewportWidth = Infinity) {
  const contentHeight = Math.max(0, viewportHeight - bannerHeight);
  return {
    contentHeight,
    rowHeight: Math.floor(contentHeight / 13),
    scale: Math.max(0, Math.min(contentHeight / 1080, viewportWidth / 1920)),
  };
}

export function tvFontSize(px: number, scale: number) {
  return Math.round(px * scale);
}

export function fitTvCanvas(
  width: number,
  height: number,
  targetWidth: number,
  targetHeight: number,
) {
  if (width <= 0 || height <= 0 || targetWidth <= 0 || targetHeight <= 0) return 0;
  return Math.min(1, width / targetWidth, height / targetHeight);
}
